import axios, { AxiosResponse } from 'axios';

import { HttpMethod } from 'exit-interview.shared/constants/httpMethod';
import { config } from 'src/config';
import { convertDates } from 'exit-interview.shared/utility/objectHelpers';

axios.interceptors.response.use((originalResponse) => {
    // Interceptor to parse dates back into date objects
    convertDates(originalResponse.data);

    return originalResponse;
});

/**
 * Use to call the API without attempting to refresh any tokens
 * 
 * Don't use this directly for any requests aside from the very few edge cases that don't require any authentication (i.e. user logging in, refreshing tokens, etc)
 * @param path 
 * @param method 
 * @param body 
 * @returns 
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function callApi<T>(path: string, method?: HttpMethod, body?: any, headers?: { [key: string]: string }): Promise<AxiosResponse<T>> {
    // eslint-disable-next-line
    const defaultHeaders: { [key: string]: string } = {
        'Content-Type': 'application/json',
    };

    const requestHeaders = !!headers
        ? headers
        : defaultHeaders;

    const cleanPath = path.startsWith('/') ? path : `/${path}`;

    return axios.request<T>({
        data: body,
        headers: requestHeaders,
        method: method || HttpMethod.GET,
        url: `${config.apiBaseUrl}${cleanPath}`,
    });
}